import { HeaderUser } from 'components/Header/HeaderProvider'

import SubMenuItem from './SubMenuItem'

type Props = {
  user: HeaderUser | null
}

const SubMenuItemsProfile = ({ user }: Props) => (
  <>
    {user && user.amountCredit.cents > 0 && (
      <p className="text-orange-500 italic font-bold p-2 -mt-4">
        You have {user.amountCredit.formatted} credits
      </p>
    )}
    <SubMenuItem href="/profile" title="Account Information" />
    <SubMenuItem href="/profile/orders" title="My Orders" />
    <SubMenuItem href="/profile/caterings" title="My Bookings" />
    <SubMenuItem href="/profile/subscriptions" title="My Subscriptions" />
    {user?.managerOfClientCompany && (
      <SubMenuItem
        href={user.managerOfClientCompany.dashboardUrl}
        title="Corporate Dashboard"
        description={user.managerOfClientCompany.name}
      />
    )}
    <SubMenuItem href="/customers/logout" title="Logout" />
  </>
)
export default SubMenuItemsProfile
